import { IBaseIconProps } from "./IBaseIconProps";

export const TrophyIcon = ({ color = "#FCE173" }: IBaseIconProps) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 4H17V10C17 12.7614 14.7614 15 12 15C9.23858 15 7 12.7614 7 10V4Z"
        fill={color}
      />
      <path
        d="M7 6H4V8C4 9.65685 5.34315 11 7 11V6Z"
        fill={color}
        fillOpacity="0.7"
      />
      <path
        d="M17 6H20V8C20 9.65685 18.6569 11 17 11V6Z"
        fill={color}
        fillOpacity="0.7"
      />
      <path d="M11 15H13V18H11V15Z" fill={color} />
      <path d="M8 18H16V20H8V18Z" fill={color} />
    </svg>
  );
};
